const ef = () => {
};

const Logger = (typeof console === 'object' ? console : {});

if (!Logger.log) {
    Logger.log = ef;
}
if (!Logger.debug) {
    Logger.debug = ef;
}
if (!Logger.info) {
    Logger.info = ef;
}
if (!Logger.warn) {
    Logger.warn = ef;
}
if (!Logger.error) {
    Logger.error = ef;
}

export default Logger;



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Logger.js